import { useEffect, useRef, useState } from "react";
import "./App.css";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GripVertical, Plus } from "lucide-react";
import { FiCircle } from "react-icons/fi";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { LuArrowUpDown } from "react-icons/lu";
import { MdOutlineLocationOn } from "react-icons/md";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { Autocomplete, TextField } from "@mui/material";
import ThankYouPopup from "./ThanksPopUp";
import { useNavigate } from "react-router-dom";

function App() {
  const url = "https://prod.justdeliveries.ai/api/api";
  // const url = "http://localhost:5000/api";
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [deliveryAgent, setDeliveryAgent] = useState(false);
  const [insurance, setInsurance] = useState(false);
  const [originCity, setOriginCity] = useState("");
  const [submit, setSubmit] = useState(false);
  // const[totalHandlingCost, setTotalHandlingCost] = useState("")
  console.log(originCity);
  const [returnPickupLocationRequire, setReturnPickupLocationRequire] =
    useState(true);
  const [destinationCity, setDestinationCity] = useState("");
  const [dashboardAccess, setDashboardAccesst] = useState(false);
  const [brandName, setBrandName] = useState();
  const [step, setStep] = useState(1);
  const [selectedService, setSelectedService] = useState("");
  const [selectedCity, setSelectedCity] = useState(originCity);
  const [selectedScope, setSelectedScope] = useState("");
  const [pickUpLocation, setPickUpLocation] = useState("");
  const [dropLocation, setDropLocation] = useState([""]);
  const [extraDrop, setExtraDrop] = useState(0);
  const [distance, setDistence] = useState(0);
  const [pickUpSuggestions, setPickUpSuggestions] = useState([]);
  const [dropSuggestions, setDropSuggestions] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [storageType, setStorageType] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [warning, setWarning] = useState("");
  const [temperature, setTemperature] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [vehicleCount, setvehicleCount] = useState(0);
  const [serviceDayCount, setServiceDayCount] = useState(0);
  const [monthlyKM, setMonthlyKM] = useState(0);
  const [quotationPerVehicle, setQuotationPerVehicle] = useState(0);
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0);
  const [noOfTrip, setNoOfTrip] = useState(1);
  const [vehicleCapacity, setVehicleCapacity] = useState("");
  const [natureOfProduct, setNatureOfProduct] = useState("");
  const [reportingCity, setReportingCity] = useState("");
  const [otherReportingCity, setOtherReportingCity] = useState("");
  const [otherDestinationCity, setOtherDestinationCity] = useState("");
  const [requirementInDetail, setRequirementInDetail] = useState("");
  const [tentativeStartDate, setTentativeStartDate] = useState("");
  const [expectedQuate, setExpectedQuate] = useState("");
  const [timeSlot, setTimeSlot] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [dragging, setDragging] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("Pallets (Min. 10 pallets)");
  const [quotePerPallet, setQuotePerPallet] = useState();
  const [totalStorageCost, setTotalStorageCost] = useState("");
  const [numInwardOutward, setNumInwardOutward] = useState("");
  const [totalHandlingCost, setTotalHandlingCost] = useState("");

  const [operationsType, setOperationsType] = useState("");
  const [valueAddedServices, setValueAddedServices] = useState([]);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  console.log(monthlyKM);
  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
    const phoneRegex = /^\d{10}$/;
    if (phone && !phoneRegex.test(phone)) {
      setPhoneError("Phone number must be 10 digits");
    } else {
      setPhoneError("");
    }
  }, [email, phone]); // runs every time email or phone changes

  const [valueAddedServicesCount, setValueAddedServicesCount] = useState({
    "WMS Access - Rs 1000 per month": 1,
    "Dedicated Supervisor - Rs 40000 per month": 1,
    "Dedicated Picker - Rs 25000 per month": 1,
    "Shared Supervisor - Rs 25000 per month": 1,
    "Shared Picker - Rs 20000 per month": 1,
  });
  // Default value
  const [monthlyKm, setMonthlyKm] = useState("");
  const [frequency, setFrequency] = useState("");
  const [quotation, setQuotation] = useState("");
  const HabdleValueAddedServicesCountChange = (key, newValue) => {
    setValueAddedServicesCount((prev) => ({
      ...prev,
      [key]: newValue,
    }));
  };
  const updateDropLocation = (index, newInputValue) => {
    const updatedLocations = [...dropLocation];
    updatedLocations[index] = newInputValue;
    setDropLocation(updatedLocations);
  };

  // Add a new drop location
  const addDropLocation = () => {
    if (dropLocation[dropLocation.length - 1]) {
      setDropLocation([...dropLocation, ""]);
    }

    const countExtraDrop = () => {
      if (dropLocation.length > 4) {
        setExtraDrop(dropLocation.length - 4);
        console.log("extraDrop", extraDrop);
        toast.info(
          "Rs 500 will be added for every extra drop (drop limit is 5)"
        );
        // alert()
      } else {
        setExtraDrop(0);
      }
    };

    if (temperature !== "Dry") {
      countExtraDrop();
    }
  };

  // Remove a drop location
  const removeDropLocation = (index) => {
    const updatedLocations = dropLocation.filter((_, i) => i !== index);
    setDropLocation(updatedLocations);

    const countExtraDrop = () => {
      if (dropLocation.length > 5) {
        setExtraDrop(dropLocation.length - 5);
        setTotalInvoiceAmount(totalInvoiceAmount - 500);
        console.log("extraDrop", extraDrop);
        toast.info(
          "Rs 500 will be removed for every extra drop (drop limit is 5)"
        );
        // alert()
      } else {
        setExtraDrop(0);
      }
    };
    if (temperature !== "Dry") {
      countExtraDrop();
    }
  };

  // Suggestions for pick-up/drop locations (if any)
  // const pickUpSuggestions = [
  //   "Location A",
  //   "Location B",
  //   "Location C",
  //   "Location D",
  // ];

  const handleSwap = () => {
    setPickUpLocation(dropLocation);
    setDropLocation(pickUpLocation);
  };

  const handleDragStart = (type) => {
    setDragging(type);
  };

  // Handle drop (swap values)
  const handleDrop = () => {
    if (dragging === "pickup") {
      handleSwap();
    }
    setDragging(null);
  };

  const handleSelectSuggestion = (suggestion) => {
    setIsDropdownVisible(false);
    setPickUpLocation(suggestion);
  };
  const handleNext = () => {
    console.log(warning);
    console.log(step);

    if (step === 1) {
      if (selectedService === "") {
        setWarning("Plesae select Service");
        return;
      } else {
        setWarning("");
      }
      if (selectedService === "Storage") {
        setStep(2);
      } else if (selectedService === "B2B Intra-city (within the city)") {
        if (temperature === "") {
          setWarning("Please select temperature");
          return;
        }
        if (temperature === "Dry") {
          setStep(4);
        } else {
          setStep(6);
        }
      } else if (
        selectedService === "B2B Inter-city (from one city to another)"
      ) {
        setStep(5);
      } else if (
        selectedService === "Shared Intra-city (ideal for 4 hours of service)"
      ) {
        setStep(3);
      }
    } else {
      setStep((prev) => prev + 1);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const getDist = async () => {
      if (!pickUpLocation || !dropLocation || dropLocation.length === 0) {
        console.error("Pick-up or Drop location not set or empty");
        return;
      }

      let totalDistance = 0;

      try {
        for (let i = 0; i < dropLocation.length; i++) {
          const source = i === 0 ? pickUpLocation : dropLocation[i - 1];
          const destination = dropLocation[i];

          const res = await axios.post(url + "/get-dist", {
            source,
            destination,
          });

          if (res?.data?.distance?.distance?.text) {
            const distanceStr = res.data.distance.distance.text.split(" ")[0];
            const distance = parseFloat(distanceStr.replace(",", "")) || 0;
            totalDistance += distance;
            console.log(
              `Distance from ${source} to ${destination}: ${distance.toFixed(
                2
              )} km`
            );
          } else {
            console.error(
              "No distance data available for",
              source,
              "to",
              destination
            );
          }
        }
        if (selectedService !== "B2B Inter-city (from one city to another)") {
          if (dropLocation.length > 0 && returnPickupLocationRequire) {
            const lastDropLocation = dropLocation[dropLocation.length - 1];
            const res = await axios.post(url + "/get-dist", {
              source: lastDropLocation,
              destination: pickUpLocation,
            });

            if (res?.data?.distance?.distance?.text) {
              const distanceStr = res.data.distance.distance.text.split(" ")[0];
              const distance = parseFloat(distanceStr.replace(",", "")) || 0;
              totalDistance += distance;
              console.log(
                `Distance from ${lastDropLocation} back to ${pickUpLocation}: ${distance.toFixed(
                  2
                )} km`
              );
            } else {
              console.error(
                "No distance data available for",
                lastDropLocation,
                "to",
                pickUpLocation
              );
            }
          }
          if (
            dropLocation.length > 0 &&
            selectedService === "B2B Inter-city (from one city to another)"
          ) {
            const lastDropLocation = dropLocation[dropLocation.length - 1];
            const res = await axios.post(url + "/get-dist", {
              source: lastDropLocation,
              destination: pickUpLocation,
            });

            if (res?.data?.distance?.distance?.text) {
              const distanceStr = res.data.distance.distance.text.split(" ")[0];
              const distance = parseFloat(distanceStr.replace(",", "")) || 0;
              totalDistance += distance;
              console.log(
                `Distance from ${lastDropLocation} back to ${pickUpLocation}: ${distance.toFixed(
                  2
                )} km`
              );
            } else {
              console.error(
                "No distance data available for",
                lastDropLocation,
                "to",
                pickUpLocation
              );
            }
          }
        }

        setDistence((totalDistance * noOfTrip).toFixed(2));
        console.log(`Total Distance: ${totalDistance.toFixed(2)} km`);
      } catch (error) {
        console.error("Error fetching distance:", error);
      }
    };
    getDist();
  }, [pickUpLocation, dropLocation, noOfTrip, returnPickupLocationRequire]); // Re-run effect when either location changes

  useEffect(() => {
    setMonthlyKM(Math.round(distance * serviceDayCount));

    setvehicleCount(parseInt(distance / 150) + 1);
  }, [serviceDayCount, distance]);

  useEffect(() => {
    let amount = Math.round(quotationPerVehicle) * vehicleCount;
    
    // Add delivery agent charges
    if (deliveryAgent) {
      if (selectedCity === "Lucknow") {
        amount = amount + (250 * serviceDayCount * vehicleCount); // ₹250 per day per vehicle for Lucknow
      } else {
        amount = amount + 25000 * vehicleCount; // Original pricing for other cities
      }
    }

    // Add dashboard access charge
    if (dashboardAccess) {
      amount = amount + 600;
    }

    // Add value added services
    let valueAddedAmount = valueAddedServices.reduce((acc, service) => {
      const priceMatch = service.match(/Rs (\d+)/);
      if (priceMatch) {
        acc += parseInt(priceMatch[1]);
      }
      return acc;
    }, 0);
    amount += valueAddedAmount;

    // Add extra drop charges
    if (selectedCity === "Lucknow") {
      if (dropLocation.length > 5) {
        amount = amount + ((dropLocation.length - 5) * 250); // ₹250 per extra drop for Lucknow
      }
    } else {
      amount = amount + (extraDrop * 500); // Original pricing for other cities
    }

    // Apply GST
    if (selectedCity === "Lucknow") {
      amount = amount * 1.18; // 18% GST for Lucknow
    } else {
      amount = amount * 1.05; // 5% GST for other cities
    }

    setTotalInvoiceAmount(Math.round(amount));
  }, [
    quotationPerVehicle,
    vehicleCount,
    deliveryAgent,
    dashboardAccess,
    valueAddedServices,
    selectedCity,
    serviceDayCount,
    dropLocation.length,
    extraDrop
  ]);

  useEffect(() => {
    console.log({ temperature });

    if (vehicleType !== "") {
      // All rates below = Client Rate per pricing sheet (City column: Delhi, Lucknow, Mumbai, South)
      // Lucknow - Client Rate
      if (selectedCity === "Lucknow") {
        if (vehicleType === "Tata Ace (600 kgs)") {
          if (monthlyKM <= 2600) {
            setQuotationPerVehicle(58000);
          } else {
            setQuotationPerVehicle(58000 + 12 * (monthlyKM - 2600));
          }
        } else if (vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)" && temperature === "Dry") {
          if (monthlyKM <= 2600) {
            setQuotationPerVehicle(79000);
          } else {
            setQuotationPerVehicle(79000 + 14 * (monthlyKM - 2600));
          }
        } else if (vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)") {
          if (monthlyKM <= 2600) {
            setQuotationPerVehicle(104000);
          } else {
            setQuotationPerVehicle(104000 + 17 * (monthlyKM - 2600));
          }
        } else if (vehicleType === "EV (3 wheeler - 500 kgs)") {
          if (monthlyKM <= 2600) {
            setQuotationPerVehicle(53000);
          } else {
            setQuotationPerVehicle(53000 + 10 * (monthlyKM - 2600));
          }
        } else if (vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)" && temperature !== "Dry") {
          if (monthlyKM <= 2600) {
            setQuotationPerVehicle(102000);
          } else {
            setQuotationPerVehicle(102000 + 22 * (monthlyKM - 2600));
          }
        }
      } else if (vehicleType === "Tata Ace (600 kgs)" && selectedCity === "Mumbai") {
        // Mumbai - Client Rate (2000/2600/3000/4000 km bands)
        if (monthlyKM <= 2000) {
          setQuotationPerVehicle(55000);
        } else if (monthlyKM > 2000 && monthlyKM <= 2600) {
          setQuotationPerVehicle(55000 + 12 * (monthlyKM - 2000));
        } else if (monthlyKM > 2600 && monthlyKM <= 3000) {
          setQuotationPerVehicle(60000 + 12 * (monthlyKM - 2600));
        } else if (monthlyKM > 3000 && monthlyKM <= 4000) {
          setQuotationPerVehicle(65000 + 12 * (monthlyKM - 3000));
        } else {
          setQuotationPerVehicle(75000 + 12 * (monthlyKM - 4000));
        }
      } else if (
        vehicleType === "Tata Ace (600 kgs)" &&
        selectedCity === "Delhi NCR"
      ) {
        // Delhi NCR - Client Rate
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(53000);
        } else if (monthlyKM > 2600 && monthlyKM <= 3000) {
          setQuotationPerVehicle(53000 + 12 * (monthlyKM - 2600));
        } else if (monthlyKM > 3000) {
          setQuotationPerVehicle(57000 + 12 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Tata Ace (600 kgs)" &&
        (selectedCity === "Bengaluru" ||
          selectedCity === "Hyderabad" ||
          selectedCity === "Chennai")
      ) {
        // South: Client Rate 60000 (2600km), 69000 (3000km) per sheet
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(60000);
        } else if (monthlyKM > 2600 && monthlyKM <= 3000) {
          setQuotationPerVehicle(60000 + 22 * (monthlyKM - 2600));
        } else if (monthlyKM > 3000) {
          setQuotationPerVehicle(69000 + 12 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (10 ft - 2500 kgs)" &&
        selectedCity === "Mumbai" &&
        temperature === "Frozen (Minus 18 °C)"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(135000);
        } else {
          setQuotationPerVehicle(130000 + 24 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)" &&
        selectedCity === "Mumbai" &&
        temperature === "Frozen (Minus 18 °C)"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(155000);
        } else {
          setQuotationPerVehicle(155000 + 24 * (monthlyKM - 3000));
        }
      } else if (
        (vehicleType === "Tata 407 or equivalent (10 ft - 2500 kgs)" ||
          vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)") &&
        selectedCity === "Mumbai" &&
        temperature === "Chilled ( 0-4, 4-8, 15-18 etc)"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(130000);
        } else {
          setQuotationPerVehicle(130000 + 24 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)" &&
        selectedCity === "Mumbai" &&
        temperature === "Chilled ( 0-4, 4-8, 15-18 etc)"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(162000);
        } else {
          setQuotationPerVehicle(162000 + 24 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)" &&
        selectedCity === "Mumbai"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(75000);
        } else {
          setQuotationPerVehicle(75000 + 14 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)" &&
        selectedCity === "Delhi NCR"
      ) {
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(99000);
        } else {
          setQuotationPerVehicle(99000 + 15 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Bolero Pick up or equivalent (8 ft - 850 kgs)" &&
        selectedCity === "Mumbai" &&
        temperature === "Chilled ( 0-4, 4-8, 15-18 etc)"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(105000);
        } else {
          setQuotationPerVehicle(105000 + 22 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)" &&
        selectedCity === "Delhi NCR" &&
        temperature === "Chilled ( 0-4, 4-8, 15-18 etc)"
      ) {
        // Delhi: Client Rate 102000 (2600km) per sheet - Refrigerated Bolero Chilled
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(102000);
        } else {
          setQuotationPerVehicle(102000 + 22 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)" &&
        (selectedCity === "Bengaluru" ||
          selectedCity === "Hyderabad" ||
          selectedCity === "Chennai") &&
        temperature === "Chilled ( 0-4, 4-8, 15-18 etc)"
      ) {
        // South: Client Rate 95000 (2600km), 102000+ for >2600 per sheet - Refrigerated Bolero Chilled
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(95000);
        } else {
          setQuotationPerVehicle(102000 + 22 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "EV (3 wheeler - 500 kgs)" &&
        selectedCity === "Delhi NCR"
      ) {
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(53000);
        } else {
          setQuotationPerVehicle(53000 + 9 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "EV (3 wheeler - 500 kgs)" &&
        (selectedCity === "Bengaluru" ||
          selectedCity === "Hyderabad" ||
          selectedCity === "Chennai")
      ) {
        // South: Client Rate 53000 (2600km) per sheet
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(53000);
        } else {
          setQuotationPerVehicle(53000 + 10 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (10 ft - 2500 kgs)" &&
        selectedCity === "Mumbai"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(95000);
        } else {
          setQuotationPerVehicle(95000 + 15 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (10 ft - 2500 kgs)" &&
        selectedCity === "Delhi NCR"
      ) {
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(98000);
        } else {
          setQuotationPerVehicle(98000 + 15 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)" &&
        (selectedCity === "Bengaluru" ||
          selectedCity === "Hyderabad" ||
          selectedCity === "Chennai") &&
        temperature === "Chilled ( 0-4, 4-8, 15-18 etc)"
      ) {
        // South: Client Rate 140000 (2600km) per sheet - Refrigerated 14ft Chilled
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(140000);
        } else {
          setQuotationPerVehicle(140000 + 24 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)" &&
        (selectedCity === "Bengaluru" ||
          selectedCity === "Hyderabad" ||
          selectedCity === "Chennai") &&
        temperature === "Frozen (Minus 18 °C)"
      ) {
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(140000);
        } else {
          setQuotationPerVehicle(140000 + 21 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)" &&
        (selectedCity === "Bengaluru" ||
          selectedCity === "Hyderabad" ||
          selectedCity === "Chennai")
      ) {
        // South: Client Rate 79000 (2600km) per sheet - Dry Bolero
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(79000);
        } else {
          setQuotationPerVehicle(79000 + 14 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (12 ft - 2500 kgs)" &&
        selectedCity === "Mumbai"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(95000);
        } else {
          setQuotationPerVehicle(95000 + 17 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (12 ft - 2500 kgs)" &&
        selectedCity === "Delhi NCR"
      ) {
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(135000);
        } else {
          setQuotationPerVehicle(135000 + 17 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)" &&
        selectedCity === "Mumbai"
      ) {
        if (monthlyKM <= 3000) {
          setQuotationPerVehicle(105000);
        } else {
          setQuotationPerVehicle(105000 + 17 * (monthlyKM - 3000));
        }
      } else if (
        vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)" &&
        selectedCity === "Delhi NCR"
      ) {
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(104000);
        } else {
          setQuotationPerVehicle(104000 + 17 * (monthlyKM - 2600));
        }
      } else if (
        vehicleType === "EV (4 wheeler - 700 kgs)" &&
        selectedCity === "Delhi NCR"
      ) {
        if (monthlyKM <= 2600) {
          setQuotationPerVehicle(75000);
        } else {
          setQuotationPerVehicle(75000 + 12 * (monthlyKM - 2600));
        }
      }
    }
  }, [monthlyKM, vehicleType, selectedCity, temperature]);

  console.log(selectedCity);

  useEffect(() => {
    setIsDropdownVisible(true);
    const getSuggestions = async () => {
      try {
        const currentInput = Array.isArray(dropLocation)
          ? dropLocation[dropLocation.length - 1] // Get the last item in the array
          : dropLocation;

        if (!currentInput) return; // Skip API call if input is empty

        console.log({ input: currentInput }); // Log the correct input now

        const res = await axios.post(url + "/get-suggestions", {
          input: currentInput, // Send only the current input
          cityName: selectedCity,
        });
        if (res?.data?.suggestions) {
          setPickUpSuggestions(
            res.data.suggestions.map((data) => data.description)
          );
        } else {
          console.error("No suggestions found");
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    };

    // Fetch suggestions for pick-up and drop locations
    getSuggestions(dropLocation, setPickUpSuggestions);

    // const countExtraDrop = () => {
    //   if (dropLocation.length > 5) {
    //     setExtraDrop(dropLocation.length - 5)
    //     console.log('extraDrop', extraDrop)
    //     alert("Rs 500 will be added for every extra drop (drop limit is 5)")
    //   }
    //   else {
    //     setExtraDrop(0)
    //   }

    // }
    // countExtraDrop()
  }, [dropLocation]);
  useEffect(() => {
    setIsDropdownVisible(true);
    const getSuggestions = async () => {
      try {
        const res = await axios.post(url + "/get-suggestions", {
          input: pickUpLocation,
          cityName: selectedCity,
        });

        if (res?.data?.suggestions) {
          console.log(res?.data?.suggestions.map((data) => data.description));
          setPickUpSuggestions(
            res?.data?.suggestions.map((data) => data.description)
          );
        } else {
          console.error("No suggestions found");
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    };

    // Fetch suggestions for pick-up and drop locations
    getSuggestions(pickUpLocation, setPickUpSuggestions);
  }, [pickUpLocation]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef?.current && !inputRef.current?.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleBack = () => {
    setStep((prev) => prev - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const fieldLabels = {
    selectedService: "Service",
    storageType: "Storage Type",
    selectedCity: "City",
    selectedArea: "Area",
    quantity: "Quantity",
    unit: "Unit",
    totalHandlingCost: "Handling Cost",
    quotePerPallet: "Quote per Pallet",
    totalStorageCost: "Storage Cost",
    numInwardOutward: "Inward/Outward Count",
    valueAddedServices: "Value Added Services",
    totalInvoiceAmount: "Invoice Amount",
    brandName: "Brand Name",
    name: "Name",
    email: "Email",
    phone: "Phone Number",
    temperature: "Temperature",
    vehicleType: "Vehicle Type",
    vehicleCount: "Vehicle Count",
    destinationCity: "Destination City",
    pickUpLocation: "Pick-up Location",
    dropLocation: "Drop Location",
    serviceDayCount: "Service Days",
    monthlyKM: "Monthly KM",
    quotationPerVehicle: "Quote per Vehicle",
    deliveryAgent: "Delivery Agent",
    insurance: "Insurance",
    dashboardAccess: "Dashboard Access",
    vehicleCapacity: "Vehicle Capacity",
    natureOfProduct: "Nature of Product",
    expectedQuate: "Expected Quote",
    tentativeStartDate: "Tentative Start Date",
    requirementInDetail: "Requirement Details",
    timeSlot: "Time Slot",
    distance: "Distance",
    frequency: "Frequency",
    quotation: "Quotation",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (emailError || phoneError) {
      toast.warning(emailError || phoneError);
      return;
    }

    let formData = {};

    if (selectedService === "Storage") {
      formData = {
        selectedService,
        storageType,
        selectedCity,
        selectedArea,
        quantity,
        unit,
        palletSize,
        totalHandlingCost,
        quotePerPallet,
        totalStorageCost,
        numInwardOutward,
        valueAddedServices,
        totalInvoiceAmount,
        brandName,
        name,
        email,
        phone,
      };
    } else if (selectedService === "B2B Intra-city (within the city)") {
      formData = {
        selectedService,
        temperature,
        vehicleType,
        vehicleCount,
        selectedCity,
        pickUpLocation,
        dropLocation,
        serviceDayCount,
        monthlyKM,
        quotationPerVehicle,
        deliveryAgent: deliveryAgent ? "Yes" : "No",
        insurance: insurance ? "Yes" : "No",
        dashboardAccess: dashboardAccess ? "Yes" : "No",
        totalInvoiceAmount,
        brandName,
        name,
        email,
        phone,
      };
    } else if (
      selectedService === "B2B Inter-city (from one city to another)"
    ) {
      formData = {
        selectedService,
        serviceDayCount,
        temperature,
        vehicleCapacity,
        natureOfProduct,
        expectedQuate,
        tentativeStartDate,
        requirementInDetail,
        selectedCity,
        destinationCity,
        pickUpLocation,
        dropLocation,
        distance,
        brandName,
        name,
        email,
        phone,
      };
    } else if (
      selectedService === "Shared Intra-city (ideal for 4 hours of service)"
    ) {
      if (distance > 50) {
        toast.error(
          "Distance is more than 50 KM. Use Dedicated model for this"
        );
        return;
      }

      formData = {
        selectedService,
        timeSlot,
        selectedCity,
        pickUpLocation,
        dropLocation,
        distance,
        monthlyKm,
        frequency,
        quotation,
        brandName,
        name,
        email,
        phone,
      };
    }

    // Fields that can be optional
    const optionalFields = ["valueAddedServices"];

    for (const key in formData) {
      if (optionalFields.includes(key)) continue;

      const value = formData[key];
      if (
        value === "" ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      ) {
        const label = fieldLabels[key] || key;
        toast.warning(`${label} is required`);
        return;
      }
    }

    // Negative number validation
    for (let key in formData) {
      if (typeof formData[key] === "number" && formData[key] < 0) {
        const label = fieldLabels[key] || key;
        toast.error(`Invalid value: ${label} cannot be negative.`);
        return;
      }
    }

    try {
      setLoading(true);

      const res = await axios.post(`${url}/get-userData`, formData);
      setLoading(false);

      if (res.status === 200) {
        setName("");
        setEmail("");
        setBrandName("");
        setPhone("");
        setSubmit(true);
        setTimeout(() => {
          setSubmit(false);
          window.location.replace("https://justdeliveries.co.in/");
        }, 3000);
      }
    } catch (error) {
      setLoading(() => (prev) => !prev);
      console.error("Error submitting form:", error);
      alert("Error submitting data. Please try again!");
    } finally {
      setLoading(false);
    }
  };
  const handleCheckboxChange = (service) => {
    setValueAddedServices((prev) =>
      prev.includes(service)
        ? prev.filter((item) => item !== service)
        : [...prev, service]
    );
  };
  console.log(loading);

  const areaOptions = {
    Mumbai: ["Bhiwandi", "Taloja"],
    Bengaluru: ["Hoskote", "Jigani", "Nelamangala"],
    "Delhi NCR": [ "Gurugram","Noida", "Lawrence Road"],
    Hyderabad: ["Medchal 1", "Medchal 2"],
    Chennai: ["Kuthambakkam","Poonamallee"],
    Pune: ["Pune"],
  };

  useEffect(() => {
    if (selectedService !== "Storage") return;

    const quotes = {
      Chennai: {
         Kuthambakkam: { Chilled: 1800, Frozen: 2400, Dry: 1200 },
         Poonamallee: { Chilled: 1800, Frozen: 2100, Dry: 1200 },
         },
      Hyderabad: {
        "Medchal 1": { Chilled: 1800, Frozen: 2300, Dry: 1000 },
        "Medchal 2": { Chilled: 1800, Frozen: 2100, Dry: 1000 },
      },
      "Delhi NCR": {
        Gurugram: { Chilled: 2600, Frozen: 3000, Dry: 2000 },
        Noida: { Chilled: 2000, Frozen: 2200, Dry: 1700 },
        "Lawrence Road": { Chilled: 2500, Frozen: 2600, Dry: 1700 },
      },
      Bengaluru: {
        Hoskote: { Chilled: 1500, Frozen: 2200, Dry: 1000 },
        Jigani: { Chilled: 1500, Frozen: 2000, Dry: 0 }, // Dry NA per sheet
        Nelamangala: { Chilled: 1500, Frozen: 2000, Dry: 1000 },
      },
      Mumbai: {
        Taloja: { Chilled: 1800, Frozen: 2200, Dry: 1200 },
        Bhiwandi: { Chilled: 1800, Frozen: 2200, Dry: 1200 },
      },
      Pune: {
        Pune: { Chilled: 1500, Frozen: 2000, Dry: 1000 },
      },
    };

    const quote = quotes[selectedCity]?.[selectedArea]?.[storageType] || 0; // Ensure quote defaults to 0
    const newStorageCost = quote * quantity;
    const newHandlingCost = numInwardOutward >= 1 ? numInwardOutward * 300 : 0;

    // Extract numeric values from checked value-added services
    const valueAddedCost = valueAddedServices.reduce((total, service) => {
      const costMatch = service.match(/Rs (\d+)/); // Extract cost from string
      return (
        total +
        (costMatch
          ? parseInt(costMatch[1]) * parseInt(valueAddedServicesCount[service])
          : 0)
      );
    }, 0);

    const newTotalInvoiceAmount =
      newStorageCost + newHandlingCost + valueAddedCost;

    setQuotePerPallet(quote);
    setTotalStorageCost(newStorageCost);
    setTotalHandlingCost(newHandlingCost);

    setTotalInvoiceAmount(newTotalInvoiceAmount + extraDrop * 500);

    console.log({
      quotePerPallet: quote,
      selectedCity,
      storageType,
      valueAddedCost,
      newTotalInvoiceAmount,
    });
  }, [
    valueAddedServicesCount,
    extraDrop,
    selectedService,
    selectedCity,
    selectedArea,
    storageType,
    quantity,
    numInwardOutward,
    valueAddedServices,
  ]);

  useEffect(() => {
    let extra = 0;

    if (distance > 50) {
      extra = (distance - 50) * 12 * frequency;
    }

    setMonthlyKm(distance * frequency);
    if (timeSlot === "8:00 am to 12:00 pm") {
      setQuotation(45000 + extra);
    }
    if (timeSlot === "2:00 pm to 6:00 pm") {
      setQuotation(35000 + extra);
    }
  }, [timeSlot, distance, frequency]);
  console.log(dropLocation);

  useEffect(() => {
    setPickUpLocation("");
    setDropLocation([""]);
    setDistence("");
    setServiceDayCount("");
    setTotalInvoiceAmount("");
    setMonthlyKM("");
    setTotalInvoiceAmount("");
    setVehicleType("");
    setQuotationPerVehicle("");
    setExtraDrop(0);
  }, [selectedCity]);
  const palletSizes = {
    Hoskote: "1000mm*1200mm*1500mm(h)",
    Jigani: "1000mm*1200mm*1500mm(h)",
    Nelamangala: "1000mm*1200mm*1500mm(h)",
    // Hoskote: "1000mm*1200mm*1500mm(h)",
    "Medchal 1": "1000mm*1200mm*1500mm(h)",
    "Medchal 2": "1000mm*1200mm*1500mm(h)",
    Ambattur: "1000mm*1200mm*1500mm(h)",
    Bhiwandi: "1000mm*1200mm*1500mm(h)",
    Taloja: "1000mm*1200mm*1500mm(h)",
    Pune: "1000mm*1200mm*1500mm(h)",
    Gurugram: "1000mm*1200mm*1500mm(h)",
    Noida: "1000mm*1200mm*1370mm(h)",
    "Lawrence Road": "1000mm*1200mm*1500mm(h)",
  };

  const palletSize = palletSizes[selectedArea] || "Size not available";

  return (
    <div>
      {submit ? (
        <div>
          {/* <ThankYouPopup />
           */}
               {window.location.href = "https://justdeliveries.co.in/thank-you/"}
        </div>
      ) : (
        <div className="back_gradient mx-auto bg-white rounded-[13px]">
          <img src="logo.png" alt="logo" className="w-[250px] mx-auto py-3" />
          <div>
            {warning !== "" && (
              <div style={{ color: "red" }}>Warning: {warning}</div>
            )}
            {/* Option choose */}
            {step === 1 && (
              <div>
                <div className="p-[30px] border-b">
                  <p className="text-sm font-medium border-b pb-3 mb-10">
                    Fill in the details to autogenerate a quote!
                  </p>

                  <div>
                    <p className="font-medium">
                      What service are you looking for? (We don't do D2C/ Home
                      deliveries)
                    </p>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        name="option"
                        checked={selectedService === "Storage"}
                        value="Storage"
                        onChange={(e) => setSelectedService(e.target.value)}
                        className="w-[20px] h-[20px]"
                      />
                      Storage
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        name="option"
                        checked={
                          selectedService === "B2B Intra-city (within the city)"
                        }
                        value="B2B Intra-city (within the city)"
                        onChange={(e) => setSelectedService(e.target.value)}
                        className="w-[20px] h-[20px]"
                      />
                      B2B Intra-city logistics (within the city)
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        name="option"
                        checked={
                          selectedService ===
                          "B2B Inter-city (from one city to another)"
                        }
                        value="B2B Inter-city (from one city to another)"
                        onChange={(e) => setSelectedService(e.target.value)}
                        className="w-[20px] h-[20px]"
                      />
                      B2B Inter-city logistics (from one city to another)
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        name="option"
                        checked={
                          selectedService ===
                          "Shared Intra-city (ideal for 4 hours of service)"
                        }
                        value="Shared Intra-city (ideal for 4 hours of service)"
                        onChange={(e) => setSelectedService(e.target.value)}
                        className="w-[20px] h-[20px]"
                      />
                      Shared Intra-city logistics (ideal for 4 hours of service)
                    </div>

                    {/* <div className='flex items-center gap-3 mt-3 text-[15px]'><input type="radio" name='option' checked={selectedService === "B2B Logistics"} value="B2B Logistics" onChange={(e) => setSelectedService(e.target.value)} className='w-[20px] h-[20px]' />B2B Logistics (QSRs, Q-comm, dark stores, B2B Clients)</div> */}
                  </div>

                  {selectedService === "B2B Intra-city (within the city)" && (
                    <div className="mb-8 mt-4">
                      <p className="font-medium">Temperature Required</p>
                      {[
                        "Dry",
                        "Chilled ( 0-4, 4-8, 15-18 etc)",
                        "Frozen (Minus 18 °C)",
                      ].map((data) => (
                        <div
                          key={data}
                          className="flex items-center gap-3 mt-3 text-[15px]"
                        >
                          <input
                            type="radio"
                            name="scope1"
                            checked={temperature === data}
                            onChange={() => setTemperature(data)}
                            className="w-[20px] h-[20px]"
                          />
                          {data}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="text-end p-[30px]">
                  <button
                    onClick={handleNext}
                    className="bg-[#167938] px-10 py-3 rounded text-white"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

            {step === 2 && (
              <div>
                <div className="p-[30px]">
                  <h1 className="text-xl font-semibold mb-5 border-b px-2 pb-3">
                    Warehousing & Storage
                  </h1>

                  {/* Storage Type */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">Type of Storage</p>
                    {["Dry", "Chilled", "Frozen"].map((type) => (
                      <div
                        key={type}
                        className="flex items-center gap-3 mt-3 text-[15px]"
                      >
                        <input
                          type="radio"
                          name="storageType"
                          value={type}
                          checked={storageType === type}
                          onChange={(e) => setStorageType(e.target.value)}
                          className="w-[20px] h-[20px]"
                        />
                        {type === "Chilled"
                          ? "Chilled (2 to 8 °C)"
                          : type === "Frozen"
                            ? "Frozen (Minus 18 °C)"
                            : type}
                      </div>
                    ))}
                  </div>

                  {/* City Selection */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      City in which the Service is required
                    </p>
                    {[
                      "Mumbai",
                      "Delhi NCR",
                      "Bengaluru",
                      "Hyderabad",
                      "Chennai",
                      "Pune",
                    ].map((city) => (
                      <div
                        key={city}
                        className="flex items-center gap-3 mt-3 text-[15px]"
                      >
                        <input
                          type="radio"
                          name="city"
                          checked={selectedCity === city}
                          onChange={() => setSelectedCity(city)}
                          className="w-[20px] h-[20px]"
                        />
                        {city}
                      </div>
                    ))}
                  </div>

                  {/* Area Selection */}
                  {selectedCity && areaOptions[selectedCity] && (
                    <div className="px-2 mb-8">
                      <p className="font-medium">
                        Areas available in {selectedCity}
                      </p>
                      {areaOptions[selectedCity].map((area) => (
                        <div
                          key={area}
                          className="flex items-center gap-3 mt-3 text-[15px]"
                        >
                          <input
                            type="radio"
                            name="area"
                            value={area}
                            checked={selectedArea === area}
                            onChange={() => setSelectedArea(area)}
                            className="w-[20px] h-[20px]"
                          />
                          {area} - {palletSizes[area]}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Storage Quantity */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">Storage Quantity</p>
                    <div className="flex">
                      <div className="w-1/3 border border-[#c3cad8] bg-[#e4e6f1] p-3">
                        Quantity
                      </div>
                      <div className="w-1/3 border border-[#c3cad8] p-3">
                        <input
                          min={0}
                          type="number"
                          value={quantity}
                          onChange={(e) => setQuantity(e.target.value)}
                          className="w-full outline-none bg-transparent"
                        />
                      </div>
                      <div className="w-1/3 border border-[#c3cad8] p-3">
                        <p className="w-full bg-transparent outline-none">
                          {unit}{" "}
                        </p>
                        {/* <select
                        value={unit}
                        onChange={(e) => setUnit(e.target.value)}
                        className="w-full bg-transparent outline-none"
                      >
                        <option value="Pallets">Pallets</option>
                        <option value="Sq Ft">Sq Ft</option>
                      </select> */}
                      </div>
                    </div>
                  </div>

                  {/* Quote Per Pallet */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">Quote per pallet for Storage</p>
                    <input
                      min={0}
                      type="number"
                      disabled
                      value={quotePerPallet}
                      // onChange={(e) => setQuotePerPallet(e.target.value)}
                      placeholder="Rs 2000"
                      className="w-[300px] px-3 py-2 outline-none border rounded"
                    />
                  </div>

                  {/* Total Storage Cost */}
                  <div className="px-2 mb-8">
                    <p className="font-medium"> Storage Cost</p>
                    <input
                      min={0}
                      type="number"
                      value={totalStorageCost}
                      disabled
                      // onChange={(e) => setTotalStorageCost(e.target.value)}
                      placeholder="0"
                      className="w-[300px] px-3 py-2 outline-none border rounded"
                    />
                  </div>

                  {/* Number of Inward/Outward */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Number of inwards and outwards per month per pallet
                    </p>
                    <input
                      min={0}
                      type="number"
                      value={numInwardOutward}
                      onChange={(e) => setNumInwardOutward(e.target.value)}
                      placeholder="e.g., 23"
                      className="w-[300px] px-3 py-2 outline-none border rounded"
                    />
                  </div>
                  <p className="px-2 mb-8">
                    Material Handling Cost (inward and outward) is Rs 300 per
                    pallet
                  </p>
                  <div className="px-2 mb-8">
                    <p className="font-medium">Total Handling Cost</p>
                    <input
                      min={0}
                      type="number"
                      value={totalHandlingCost}
                      // onChange={(e) => setNumInwardOutward(e.target.value)}
                      placeholder="e.g., 23"
                      className="w-[300px] px-3 py-2 outline-none border rounded"
                    />
                  </div>

                  {/* Value Added Services */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">Value Added Services</p>
                    {[
                      "WMS Access - Rs 1000 per month",
                      "Dedicated Supervisor - Rs 40000 per month",
                      "Dedicated Picker - Rs 25000 per month",
                      "Shared Supervisor - Rs 25000 per month",
                      "Shared Picker - Rs 20000 per month",
                    ].map((service) => (
                      <div
                        key={service}
                        className="flex items-center gap-3 mt-3 text-[15px]"
                      >
                        <input
                          type="checkbox"
                          checked={valueAddedServices.includes(service)}
                          onChange={() => handleCheckboxChange(service)}
                          className="w-[20px] h-[20px]"
                        />
                        {valueAddedServices.includes(service) &&
                          service !== "WMS Access - Rs 1000 per month" && (
                            <>
                              <label>Enter Number</label>
                              <input
                                className="w-[300px] px-3 py-2 outline-none border rounded"
                                value={valueAddedServicesCount[service]}
                                onChange={(e) => {
                                  HabdleValueAddedServicesCountChange(
                                    service,
                                    e.target.value
                                  );
                                }}
                                type="text"
                              ></input>
                            </>
                          )}
                        {service}
                      </div>
                    ))}
                  </div>

                  {/* Total Invoice Amount */}
                  <div className="px-2  mb-8">
                    <p className="font-medium">Total Invoice Amount</p>
                    <input
                      type="text"
                      value={totalInvoiceAmount}
                      onChange={(e) => setTotalInvoiceAmount(e.target.value)}
                      placeholder="e.g., 23"
                      className="w-[300px] px-3 py-2 outline-none border rounded"
                    />
                    <span className="text-xs block">
                      18% GST Exclusive on FCM basis
                    </span>
                  </div>

                  {/* User Details */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Please fill in your details to receive a call back
                    </p>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Brand Name</div>
                      <input
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Name</div>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Email ID</div>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <label className="text-red-500">{emailError}</label>
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Contact No.</div>
                      <input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <br />{" "}
                      <label className="text-red-500">{phoneError}</label>
                    </div>
                  </div>
                </div>

                {/* Navigation Buttons */}
                <div className="border-t flex items-center justify-between p-8">
                  <button
                    onClick={handleBack}
                    className="bg-[#167938] px-10 py-3 rounded text-white"
                  >
                    Back
                  </button>
                  <button
                    disabled={loading}
                    onClick={handleSubmit}
                    className="bg-[#167938] px-10 py-3 rounded text-white"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}

            {/* Shared model */}
            {step === 3 && (
              <div>
                <div className="p-[30px]">
                  <div className="border-b mb-5 pb-3 px-2">
                    <h1 className="text-xl font-semibold mb-1">Shared Model</h1>
                    <p className="font-medium">
                      Vehicle available - Dry Tata Ace or equivalent (500-650
                      kgs loading capacity)
                    </p>
                  </div>

                  {/* Choose Slot */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">Choose your slot</p>
                    {["8:00 am to 12:00 pm", "2:00 pm to 6:00 pm"].map(
                      (slot) => (
                        <div
                          key={slot}
                          className="flex items-center gap-3 mt-3 text-[15px]"
                        >
                          <input
                            type="radio"
                            name="timeSlot"
                            value={slot}
                            checked={timeSlot === slot}
                            onChange={(e) => setTimeSlot(e.target.value)}
                            className="w-[20px] h-[20px]"
                          />
                          {slot}
                        </div>
                      )
                    )}
                  </div>
                  <div className="flex flex-col gap-6 my-4 ml-2">
                    <select
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                      className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                    >
                      <option value="">Select City</option>
                      <option value="Mumbai">Mumbai</option>
                      <option value="Lucknow">Lucknow</option>
                       <option value="Bangalore">Bangalore</option>
                    
                      <option value="Delhi NCR">Delhi NCR</option>
                      <option value="Hyderabad">Hyderabad</option>
                      <option value="Chennai">Chennai</option>
                      <option value="Other">Other</option>
                    </select>
                    {/* {selectedCity !== "Other" &&
                  {/* {selectedCity !== "Other" &&
                    <select
                      value={destinationCity}
                      onChange={e => setDestinationCity(e.target.value)}
                      className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                    >
                      <option value="">Select Destination City</option>
                      <option value="Mumbai">Mumbai</option>
                      <option value="Bangalore">Bangalore</option>
                      <option value="Delhi NCR">Delhi NCR</option>
                      <option value="Hyderabad">Hyderabad</option>
                      <option value="Chennai">Chennai</option>
                      <option value="Other">Other</option>
                    </select>
                  }
   */}
                  </div>
                  {selectedCity !== "Other" ||
                    (destinationCity !== "Other" && (
                      <div>
                        <input
                          type="text"
                          placeholder="Please enter your city"
                          className=" border px-3 py-2 rounded w-[300px] ml-2 my-4"
                        />
                      </div>
                    ))}

                  {selectedCity !== "Other" && destinationCity !== "Other" && (
                    <div>
                      <div className="relative">
                        {/* Pick Up Location */}
                        <div className="px-2 mb-5">
                          <Autocomplete
                            value={pickUpLocation}
                            onInputChange={(_, newInputValue) =>
                              setPickUpLocation(newInputValue)
                            }
                            options={pickUpSuggestions}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Choose Pick-up location"
                              />
                            )}
                          />
                        </div>

                        {/* Render multiple Drop Locations */}
                        {dropLocation.map((location, index) => (
                          <div key={index} className="px-2 mb-5 relative group">
                            <Autocomplete
                              value={location}
                              onInputChange={(_, newInputValue) =>
                                updateDropLocation(index, newInputValue)
                              }
                              options={pickUpSuggestions}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={`Choose Drop location ${index + 1}`}
                                />
                              )}
                            />

                            {/* Add Location Button after selecting a drop location */}
                            {location && index === dropLocation.length - 1 && (
                              <button
                                onClick={addDropLocation}
                                className="mt-2 flex items-center gap-2 text-sm text-blue-600 hover:underline"
                              >
                                <Plus className="w-[14px]" /> Add Location
                              </button>
                            )}

                            {/* Remove Button if more than 1 drop location */}
                            {dropLocation.length > 1 && (
                              <button
                                onClick={() => removeDropLocation(index)}
                                className="absolute top-5 -right-3 text-red-500 text-base hover:underline"
                              >
                                <IoMdCloseCircleOutline />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">Choose</p>
                        {["Is return logistics to the pickup location required?"].map((slot) => (
                          <div
                            key={slot}
                            className="flex items-center gap-3 mt-3 text-[15px]"
                          >
                            <input
                              type="checkbox"
                              name="returnPickupLocationRequire"
                              value="returnPickupLocationRequire"
                              checked={returnPickupLocationRequire}
                              onChange={(e) =>
                                setReturnPickupLocationRequire((prev) => !prev)
                              }
                              className="w-[20px] h-[20px]"
                            />
                            {slot}
                          </div>
                        ))}
                      </div>

                      {/* KM Run Per Day */}
                      <div className="px-2 mb-8">
                        <p className="font-medium">KM run per day</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            value={distance}
                            disabled={true}
                            type="text"
                            placeholder="30 km"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">to and from</span>
                        {distance >= 50 && (
                          <span className="text-xs text-red-500">
                            {" "}
                            Warning: The distance exceeds 50 km. An extra cost
                            of ₹12 per km will apply beyond 50 km in final
                            quotation. We suggest going for a dedicated model.
                          </span>
                        )}
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          Frequency (#days of service required in a month)
                        </p>
                        {/* <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        name="frequency"
                        value="Upto 26 days"
                        checked={frequency === "Upto 26 days"}
                        onChange={(e) => setFrequency(e.target.value)}
                        className="w-[20px] h-[20px]"
                      />
                      Upto 26 days
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        name="frequency"
                        value="1 days - additional charges on sundays"
                        checked={frequency === "1 days - additional charges on sundays"}
                        onChange={(e) => setFrequency(e.target.value)}
                        className="w-[20px] h-[20px]"
                      />
                      1 days - additional charges on sundays
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        name="frequency"
                        value="Others"
                        checked={frequency === "Others"}
                        onChange={(e) => setFrequency(e.target.value)}
                        className="w-[20px] h-[20px]"
                      />
                      Others
                    </div> */}
                        <div>
                          <input
                            value={frequency}
                            type="number"
                            min={0}
                            max={31}
                            placeholder="Enter Frequency"
                            className="w-[300px] mt-3 px-3 py-2 outline-none border rounded"
                            // onChange={(e) => setFrequency(e.target.value)}
                            onChange={(e) => {
                              const input = e.target.value;

                              // Allow empty input for typing/editing
                              if (input === "") {
                                setFrequency("");
                                return;
                              }

                              const value = parseInt(input, 10);

                              if (value < 1 || value > 31) {
                                toast.error(
                                  "Please enter a number between 1 and 31"
                                );
                                return;
                              }

                              setFrequency(value);
                            }}
                          />
                        </div>
                      </div>

                      {/* Monthly KM Run */}
                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          Monthly Km run (upto 3000 km)
                        </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            disabled
                            value={monthlyKm}
                            onChange={(e) => setMonthlyKm(e.target.value)}
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                      </div>

                      {/* Frequency */}

                      {/* Quotation per Vehicle */}
                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          Quotation per vehicle (Includes driver, fuel, vehicle,
                          live tracking link)
                        </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            min={0}
                            type="number"
                            value={quotation}
                            disabled={true}
                            onChange={(e) => setQuotation(e.target.value)}
                            placeholder="Rs 80000"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">
                          Does not include tolls, parking, DA, 5% GST
                        </span>
                      </div>
                    </div>
                  )}
                  {/* Pick-up Location */}

                  {/* Frequency */}

                  {/* User Details */}
                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Please fill in your details to receive a call back
                    </p>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Brand Name</div>
                      <input
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Name</div>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Email ID</div>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <label className="text-red-500">{emailError}</label>
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Contact No.</div>
                      <input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <br />{" "}
                      <label className="text-red-500">{phoneError}</label>
                    </div>
                  </div>
                </div>

                {/* Navigation Buttons */}
                <div className="border-t flex items-center justify-between p-8">
                  <button
                    onClick={handleBack}
                    className="bg-[#167938] px-10 py-3 rounded text-white"
                  >
                    Back
                  </button>
                  <button
                    disabled={loading}
                    onClick={handleSubmit}
                    className="bg-[#142272] px-10 py-3 rounded text-white"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}

            {/* Intra city */}
            {step === 4 && (
              <div>
                <div className="p-[30px]">
                  <h1 className="text-xl font-semibold mb-5 border-b px-2 pb-3">
                    {selectedCity === "Delhi NCR" && <>North</>}{" "}
                    {selectedCity === "Lucknow" && <>North</>}{" "}
                    {selectedCity === "Bengaluru" && <>South</>}{" "}
                    {selectedCity === "Hyderabad" && <>South</>}{" "}
                    {selectedCity === "Chennai" && <>South</>}{" "}
                    {selectedCity === "Mumbai" && <>West</>} Region -{" "}
                    {temperature === "Dry" ? <>Dry</> : <>Cold Chain</>} Vehicle
                    Logistics
                  </h1>

                  <div className="flex flex-col gap-6 my-4 ml-2">
                    <select
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                      className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                    >
                      <option value="">Select City</option>
                      <option value="Mumbai">Mumbai</option>
                      <option value="Lucknow">Lucknow</option>
                      <option value="Bengaluru">Bangalore</option>
                      <option value="Delhi NCR">Delhi NCR</option>
                      <option value="Hyderabad">Hyderabad</option>
                      <option value="Chennai">Chennai</option>
                      <option value="Other">Other</option>
                    </select>
                    {selectedCity !== "Other" ||
                      (selectedService !==
                        "B2B Intra-city (within the city)" && (
                          <select
                            value={destinationCity}
                            onChange={(e) => setDestinationCity(e.target.value)}
                            className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                          >
                            <option value="">Select Destination City</option>
                            <option value="Mumbai">Mumbai</option>
                            <option value="Bangalore">Bangalore</option>
                            <option value="Delhi NCR">Delhi NCR</option>
                            <option value="Hyderabad">Hyderabad</option>
                            <option value="Chennai">Chennai</option>
                            <option value="Other">Other</option>
                          </select>
                        ))}
                  </div>
                  {selectedCity !== "Other" ||
                    (destinationCity !== "Other" && (
                      <div>
                        <input
                          type="text"
                          placeholder="Please enter your city"
                          className=" border px-3 py-2 rounded w-[300px] ml-2 my-2"
                        />
                      </div>
                    ))}

                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Type of Vehicle required (payload capacity)
                    </p>
                    {selectedCity === "Lucknow" && (
                      <>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10" 
                            checked={vehicleType === "Tata Ace (600 kgs)"}
                            value="Tata Ace (600 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata Ace (600 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={vehicleType === "EV (3 wheeler - 500 kgs)"}
                            value="EV (3 wheeler - 500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value); 
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          EV (3 wheeler - 500 kgs)
                        </div>  
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          {/*Bolero Pick up or equivalent (8 ft - 1000 kgs */}
                          <input
                            type="radio"
                            name="option10"
                            checked={vehicleType === "Bolero Pick up or equivalent (8 ft - 1000 kgs)"}
                            value="Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Bolero Pick up or equivalent (8 ft - 1000 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                        {/* Tata 407 or equivalent (14 ft - 2500 kgs) */}
                        <input
                            type="radio"
                            name="option10"
                            checked={vehicleType === "Tata 407 or equivalent (14 ft - 2500 kgs)"}
                            value="Tata 407 or equivalent (14 ft - 2500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (14 ft - 2500 kgs)   
                        </div>

                        </>
                    )}
                    
                    {selectedCity === "Mumbai" && (
                      <>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={vehicleType === "Tata Ace (600 kgs)"}
                            value="Tata Ace (600 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata Ace (600 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                            }
                            value="Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Bolero Pick up or equivalent (8 ft - 1000 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (10 ft - 2500 kgs)"
                            }
                            value="Tata 407 or equivalent (10 ft - 2500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (10 ft - 2500 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (12 ft - 2500 kgs)"
                            }
                            value="Tata 407 or equivalent (12 ft - 2500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (12 ft - 2500 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (14 ft - 2500 kgs)"
                            }
                            value="Tata 407 or equivalent (14 ft - 2500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (14 ft - 2500 kgs)
                        </div>
                      </>
                    )}
                    {selectedCity === "Delhi NCR" && (
                      <>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={vehicleType === "Tata Ace (600 kgs)"}
                            value="Tata Ace (600 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata Ace (600 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={vehicleType === "EV (3 wheeler - 500 kgs)"}
                            value="EV (3 wheeler - 500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          EV (3 wheeler - 500 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={vehicleType === "EV (4 wheeler - 700 kgs)"}
                            value="EV (4 wheeler - 700 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          EV (4 wheeler - 700 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                            }
                            value="Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Bolero Pick up or equivalent (8 ft - 1000 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (10 ft - 2500 kgs)"
                            }
                            value="Tata 407 or equivalent (10 ft - 2500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (10 ft - 2500 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (12 ft - 2500 kgs)"
                            }
                            value="Tata 407 or equivalent (12 ft - 2500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (12 ft - 2500 kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (14 ft - 2500 kgs)"
                            }
                            value="Tata 407 or equivalent (14 ft - 2500 kgs)"
                            onClick={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (14 ft - 2500 kgs)
                        </div>
                      </>
                    )}
                    {(selectedCity === "Bengaluru" ||
                      selectedCity === "Hyderabad" ||
                      selectedCity === "Chennai") && (
                        <>
                          <div className="flex items-center gap-3 mt-3 text-[15px]">
                            <input
                              type="radio"
                              name="option10"
                              checked={vehicleType === "Tata Ace (600 kgs)"}
                              value="Tata Ace (600 kgs)"
                              onClick={(e) => {
                                setVehicleType(e.target.value);
                              }}
                              className="w-[20px] h-[20px]"
                            />
                            Tata Ace (600 kgs)
                          </div>
                          <div className="flex items-center gap-3 mt-3 text-[15px]">
                            <input
                              type="radio"
                              name="option10"
                              checked={vehicleType === "EV (3 wheeler - 500 kgs)"}
                              value="EV (3 wheeler - 500 kgs)"
                              onClick={(e) => {
                                setVehicleType(e.target.value);
                              }}
                              className="w-[20px] h-[20px]"
                            />
                            EV (3 wheeler - 500 kgs)
                          </div>
                          <div className="flex items-center gap-3 mt-3 text-[15px]">
                            <input
                              type="radio"
                              name="option10"
                              checked={
                                vehicleType ===
                                "Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                              }
                              value="Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                              onClick={(e) => {
                                setVehicleType(e.target.value);
                              }}
                              className="w-[20px] h-[20px]"
                            />
                            Bolero Pick up or equivalent (8 ft - 1000 kgs)
                          </div>
                          <div className="flex items-center gap-3 mt-3 text-[15px]">
                            <input
                              type="radio"
                              name="option10"
                              checked={
                                vehicleType ===
                                "Tata 407 or equivalent (10 ft - 2500 kgs)"
                              }
                              value="Tata 407 or equivalent (10 ft - 2500 kgs)"
                              onClick={(e) => {
                                setVehicleType(e.target.value);
                              }}
                              className="w-[20px] h-[20px]"
                            />
                            Tata 407 or equivalent (10 ft/12 ft - 2500 kgs)
                          </div>
                        </>
                      )}
                  </div>

                  <div className="px-2 mb-8">
                    <p className="font-medium">Number of vehicles required</p>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="number"
                        placeholder="4"
                        value={vehicleCount}
                        onChange={(e) => setvehicleCount(e.target.value)}
                        className="w-[300px] px-3 py-2 outline-none border rounded"
                      />
                    </div>
                  </div>

                  {selectedCity !== "Other" && destinationCity !== "Other" && (
                    <div>
                      <div className="relative">
                        {/* Pick Up Location */}
                        <div className="px-2 mb-5">
                          <Autocomplete
                            value={pickUpLocation}
                            onInputChange={(_, newInputValue) =>
                              setPickUpLocation(newInputValue)
                            }
                            options={pickUpSuggestions}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Choose  Pick-up location"
                              />
                            )}
                          />
                        </div>

                        {/* Render multiple Drop Locations */}
                        {dropLocation.map((location, index) => (
                          <div key={index} className="px-2 mb-5 relative group">
                            <Autocomplete
                              value={location}
                              onInputChange={(_, newInputValue) =>
                                updateDropLocation(index, newInputValue)
                              }
                              options={pickUpSuggestions}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={`Choose  Drop location ${index + 1}`}
                                />
                              )}
                            />

                            {/* Add Location Button after selecting a drop location */}
                            {location && index === dropLocation.length - 1 && (
                              <button
                                onClick={addDropLocation}
                                className="mt-2 flex items-center gap-2 text-sm text-blue-600 hover:underline"
                              >
                                <Plus className="w-[14px]" /> Add Location
                              </button>
                            )}

                            {/* Remove Button if more than 1 drop location */}
                            {dropLocation.length > 1 && (
                              <button
                                onClick={() => removeDropLocation(index)}
                                className="absolute top-5 -right-3 text-red-500 text-base hover:underline"
                              >
                                <IoMdCloseCircleOutline />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">No. of trip in a day</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="number"
                            value={noOfTrip}
                            onChange={(e) => setNoOfTrip(e.target.value)}
                            disabled={false}
                            placeholder="85 km"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">to and from</span>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          KMs run per day (start and end location to be same for
                          calculation)
                        </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            value={distance}
                            disabled={true}
                            type="text"
                            placeholder=" E.g 85 km"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">to and from</span>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          Frequency of deliveries (#days of service required in
                          a month)
                        </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            placeholder="E.g 26"
                            min={0}
                            max={31}
                            value={serviceDayCount}
                            onChange={(e) => {
                              const input = e.target.value;

                              // Allow empty input for typing/editing
                              if (input === "") {
                                setServiceDayCount("");
                                return;
                              }

                              const value = parseInt(input, 10);

                              if (isNaN(value) || value < 1 || value > 31) {
                                toast.error(
                                  "Please enter a number between 1 and 31"
                                );
                                return;
                              }

                              setServiceDayCount(value);
                            }}
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">Total Monthly KM</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            value={monthlyKM}
                            disabled={true}
                            placeholder="0"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          Quotation per vehicle (Includes driver, fuel, vehicle)
                        </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            value={quotationPerVehicle}
                            disabled={true}
                            placeholder="Rs 55000"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">
                          Does not include tolls, parking, Delievery assistant,
                          5% GST
                        </span>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">Value Added Services</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="checkbox"
                            checked={dashboardAccess}
                            onChange={() =>
                              setDashboardAccesst((prev) => !prev)
                            }
                            className="w-[20px] h-[20px]"
                          />
                          Dashboard Access - Rs 600 per month
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="checkbox"
                            checked={insurance}
                            onChange={() => setInsurance((prev) => !prev)}
                            className="w-[20px] h-[20px]"
                          />
                          Insurance - 0.5% of the value of goods in transit
                          calculated when services commence
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="checkbox"
                            checked={deliveryAgent}
                            onChange={() => setDeliveryAgent((prev) => !prev)}
                            className="w-[20px] h-[20px]"
                          />
                          Delivery Agent - Rs 25000 per month
                        </div>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">Total Invoice Amount</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            value={totalInvoiceAmount}
                            disabled={true}
                            placeholder="e.g., 23"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">
                          5% GST Exclusive on RCM basis
                        </span>
                        <br />
                      </div>
                    </div>
                  )}

                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Please fill in your details to receive a call back
                    </p>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Brand Name</div>
                      <input
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Name</div>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Email ID</div>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <label className="text-red-500">{emailError}</label>
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Contact No.</div>
                      <input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <br />{" "}
                      <label className="text-red-500">{phoneError}</label>
                    </div>
                  </div>

                  <div className="px-2  mb-9">
                    <p className="font-medium mb-2">
                      Brief Description of your brand and nature of services
                      required
                    </p>
                    <textarea
                      cols="30"
                      rows="5"
                      className="w-full border px-3 py-2 rounded"
                    ></textarea>
                  </div>

                  {/* <div className='px-2 mb-9'>
                  Do you want a quote for storage too? Click on "Next" and check it out.
                </div> */}
                </div>
                <div className="border-t flex items-center justify-between p-8">
                  <button
                    onClick={() => {
                      setStep(1);
                    }}
                    className="bg-[#167938] px-10 py-3 rounded text-white"
                  >
                    Back
                  </button>
                  <button
                    disabled={loading}
                    onClick={handleSubmit}
                    className="bg-[#142272] px-10 py-3 rounded text-white"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}

            {step === 6 && (
              <div>
                <div className="p-[30px]">
                  <h1 className="text-xl font-semibold mb-5 border-b px-2 pb-3">
                    {selectedCity === "Delhi NCR" && <>North</>}{" "}
                    {selectedCity === "Bengaluru" && <>South</>}{" "}
                    {selectedCity === "Hyderabad" && <>South</>}{" "}
                    {selectedCity === "Chennai" && <>South</>}{" "}
                    {selectedCity === "Mumbai" && <>West</>} Region - Cold Chain
                    Vehicle Logistics
                  </h1>

                  <div className="flex flex-col gap-6 my-4 ml-2">
                    <select
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                      className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                    >
                      <option value="">Select City</option>
                      <option value="Mumbai">Mumbai</option>
                      <option value="Bengaluru">Bengaluru</option>
                      <option value="Lucknow">Lucknow</option>
                      <option value="Delhi NCR">Delhi NCR</option>
                      <option value="Hyderabad">Hyderabad</option>
                      <option value="Chennai">Chennai</option>
                      <option value="Other">Other</option>
                    </select>
                    {selectedCity !== "Other" ||
                      (selectedService !==
                        "B2B Intra-city (within the city)" && (
                          <select
                            value={destinationCity}
                            onChange={(e) => setDestinationCity(e.target.value)}
                            className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                          >
                            <option value="">Select Destination City</option>
                            <option value="Mumbai">Mumbai</option>
                            <option value="Bengaluru">Bengaluru</option>
                            <option value="Lucknow">Lucknow</option>
                            <option value="Delhi NCR">Delhi NCR</option>
                            <option value="Hyderabad">Hyderabad</option>
                            <option value="Chennai">Chennai</option>
                            <option value="Other">Other</option>
                          </select>
                        ))}
                  </div>
                  {selectedCity !== "Other" ||
                    (destinationCity !== "Other" && (
                      <div>
                        <input
                          type="text"
                          placeholder="Please enter your city"
                          className=" border px-3 py-2 rounded w-[300px] ml-2 my-4"
                        />
                      </div>
                    ))}

                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Type of Vehicle required (payload capacity)
                    </p>
                    {selectedCity==='Lucknow' && (
                       <div className="flex items-center gap-3 mt-3 text-[15px]">
                       <input
                         type="radio"
                         name="option10"
                         checked={
                           vehicleType ===
                           "Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                         }
                         onChange={(e) => {
                           setVehicleType(e.target.value);
                         }}
                         value="Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                         className="w-[20px] h-[20px]"
                       />
                       Bolero Pik-Up (8 feet- 1000kgs)
                     </div>
                    )}
                       
                    {selectedCity === "Mumbai" && (
                      <>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Bolero Pick up or equivalent (8 ft - 850 kgs)"
                            }
                            onChange={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            value="Bolero Pick up or equivalent (8 ft - 850 kgs)"
                            className="w-[20px] h-[20px]"
                          />
                          Bolero Pik-Up (8 feet- 850kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (10 ft - 2500 kgs)"
                            }
                            onChange={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            value="Tata 407 or equivalent (10 ft - 2500 kgs)"
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (10/12 ft)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (14 ft - 2500 kgs)"
                            }
                            onChange={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            value="Tata 407 or equivalent (14 ft - 2500 kgs)"
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (14 feet- 2500kgs)
                        </div>
                      </>
                    )}
                    {selectedCity === "Delhi NCR" && (
                      <>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                            }
                            onChange={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            value="Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                            className="w-[20px] h-[20px]"
                          />
                          Bolero Pik-Up (8 feet- 1000kgs)
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="radio"
                            name="option10"
                            checked={
                              vehicleType ===
                              "Tata 407 or equivalent (14 ft - 2500 kgs)"
                            }
                            onChange={(e) => {
                              setVehicleType(e.target.value);
                            }}
                            value="Tata 407 or equivalent (14 ft - 2500 kgs)"
                            className="w-[20px] h-[20px]"
                          />
                          Tata 407 or equivalent (14 feet- 2500kgs)
                        </div>
                      </>
                    )}
                    {(selectedCity === "Bengaluru" ||
                      selectedCity === "Hyderabad" ||
                      selectedCity === "Chennai") && (
                        <>
                          <div className="flex items-center gap-3 mt-3 text-[15px]">
                            <input
                              type="radio"
                              name="option10"
                              checked={
                                vehicleType ===
                                "Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                              }
                              onChange={(e) => {
                                setVehicleType(e.target.value);
                              }}
                              value="Bolero Pick up or equivalent (8 ft - 1000 kgs)"
                              className="w-[20px] h-[20px]"
                            />
                            1 MT Bolero Pik-Up (8 feet)
                          </div>
                          <div className="flex items-center gap-3 mt-3 text-[15px]">
                            <input
                              type="radio"
                              name="option10"
                              checked={
                                vehicleType ===
                                "Tata 407 or equivalent (14 ft - 2500 kgs)"
                              }
                              onChange={(e) => {
                                setVehicleType(e.target.value);
                              }}
                              value="Tata 407 or equivalent (14 ft - 2500 kgs)"
                              className="w-[20px] h-[20px]"
                            />
                            Tata 407 or equivalent (14 feet- 2500kgs)
                          </div>
                        </>
                      )}
                  </div>

                  <div className="px-2 mb-8">
                    <p className="font-medium">Number of vehicles required</p>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="text"
                        placeholder="4"
                        min={0}
                        value={vehicleCount}
                        onChange={(e) => setvehicleCount(e.target.value)}
                        className="w-[300px] px-3 py-2 outline-none border rounded"
                      />
                    </div>
                  </div>

                  {selectedCity !== "Other" && destinationCity !== "Other" && (
                    <div>
                      {/* Drop Location */}
                      <div className="relative">
                        {/* Pick Up Location */}
                        <div className="px-2 mb-5">
                          <Autocomplete
                            value={pickUpLocation}
                            onInputChange={(_, newInputValue) =>
                              setPickUpLocation(newInputValue)
                            }
                            options={pickUpSuggestions}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Choose Pick-up location"
                              />
                            )}
                          />
                        </div>

                        {/* Render multiple Drop Locations */}
                        {dropLocation.map((location, index) => (
                          <div key={index} className="px-2 mb-5 relative group">
                            <Autocomplete
                              value={location}
                              onInputChange={(_, newInputValue) =>
                                updateDropLocation(index, newInputValue)
                              }
                              options={pickUpSuggestions}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={`Choose Drop location ${index + 1}`}
                                />
                              )}
                            />

                            {/* Add Location Button after selecting a drop location */}
                            {location && index === dropLocation.length - 1 && (
                              <button
                                onClick={addDropLocation}
                                className="mt-2 flex items-center gap-2 text-sm text-blue-600 hover:underline"
                              >
                                <Plus className="w-[14px]" /> Add Location
                              </button>
                            )}

                            {/* Remove Button if more than 1 drop location */}
                            {dropLocation.length > 1 && (
                              <button
                                onClick={() => removeDropLocation(index)}
                                className="absolute top-5 -right-3 text-red-500 text-base hover:underline"
                              >
                                <IoMdCloseCircleOutline />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">No. of trip in a day</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="number"
                            value={noOfTrip}
                            onChange={(e) => setNoOfTrip(e.target.value)}
                            disabled={false}
                            placeholder="85 km"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">to and from</span>
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">KMs run per day</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            value={distance}
                            disabled={true}
                            type="text"
                            placeholder="85 km"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">to and from</span>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          Frequency of deliveries (#days of service required in
                          a month)
                        </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            min={0}
                            max={31}
                            value={serviceDayCount}
                            onChange={(e) => {
                              console.log("hittttttttttttttttttttttttttttttt");


                              const input = e.target.value;

                              // Allow empty input for typing/editing
                              if (input === "") {
                                setServiceDayCount("");
                                return;
                              }

                              const value = parseInt(input, 10);

                              if (isNaN(value) || value < 1 || value > 31) {
                                toast.error(
                                  "Please enter a number between 1 and 31"
                                );
                                return;
                              }

                              setServiceDayCount(value);
                            }}
                            placeholder="26"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">Total Monthly KM</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            disabled={true}
                            value={monthlyKM}
                            type="text"
                            placeholder="0"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">
                          Quotation per vehicle (Includes driver, fuel, vehicle)
                        </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            value={quotationPerVehicle}
                            disabled={true}
                            placeholder="Rs 55000"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">
                          Does not include tolls, parking, DA, 5% GST
                        </span>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">Value Added Services</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="checkbox"
                            checked={dashboardAccess}
                            onChange={() =>
                              setDashboardAccesst((prev) => !prev)
                            }
                            className="w-[20px] h-[20px]"
                          />
                          Dashboard Access - Rs 600 per month
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="checkbox"
                            checked={insurance}
                            onChange={() => setInsurance((prev) => !prev)}
                            className="w-[20px] h-[20px]"
                          />
                          Insurance - 0.5% of the value of goods in transit
                          calculated when services commence
                        </div>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="checkbox"
                            checked={deliveryAgent}
                            onChange={() => setDeliveryAgent((prev) => !prev)}
                            className="w-[20px] h-[20px]"
                          />
                          Delivery Agent - Rs 22000 per month
                        </div>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">Total Invoice Amount</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            value={totalInvoiceAmount}
                            disabled={true}
                            placeholder="e.g., 23"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        <span className="text-xs">
                          5% GST Exclusive on RCM basis
                        </span>
                        <br />
                        {dropLocation.length > 5 && (
                          <span className="text-xs text-red-500">
                            Warning: More than 5 drop locations. Additional
                            charges applyed. Extra amount: ₹
                            {(dropLocation.length - 5) * 500}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Please fill in your details to receive a call back
                    </p>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Brand Name</div>
                      <input
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Name</div>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Email ID</div>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <label className="text-red-500">{emailError}</label>
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Contact No.</div>
                      <input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <br />{" "}
                      <label className="text-red-500">{phoneError}</label>
                    </div>
                  </div>
                  <div className="px-2  mb-9">
                    <p className="font-medium mb-2">
                      Brief Description of your brand and nature of services
                      required
                    </p>
                    <textarea
                      cols="30"
                      rows="5"
                      className="w-full border px-3 py-2 rounded"
                    ></textarea>
                  </div>

                  {/* <div className='px-2 mb-9'>
                  Do you want a quote for storage too? Click on "Next" and check it out.
                </div> */}
                </div>
                <div className="border-t flex items-center justify-between p-8">
                  <button
                    onClick={() => {
                      setStep(1);
                    }}
                    className="bg-[#167938] px-10 py-3 rounded text-white"
                  >
                    Back
                  </button>
                  <button
                    disabled={loading}
                    onClick={handleSubmit}
                    className="bg-[#142272] px-10 py-3 rounded text-white"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}

            {step === 5 && (
              <div>
                <div className="p-[30px]">
                  <h1 className="text-xl font-semibold mb-5 border-b px-2 pb-3">
                    Inter-city Logistics
                  </h1>

                  <div className="px-2 mb-8">
                    <p className="font-medium">Frequency</p>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <select
                        value={serviceDayCount}
                        onChange={(e) => setServiceDayCount(e.target.value)}
                        className="w-[300px] px-3 py-2 outline-none border rounded"
                      >
                        <option value=" ">Select Frequency</option>
                        <option value="Adhoc(once)">Adhoc (once)</option>
                        <option value="Regular Trips Required">
                          Regular trips required
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="px-2 mb-8">
                    <p className="font-medium">Temperature Required</p>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <select
                        value={temperature}
                        onChange={(e) => setTemperature(e.target.value)}
                        className="w-[300px] px-3 py-2 outline-none border   rounded"
                      >
                        <option value=" ">Select Temperature</option>
                        <option value="Dry">Dry</option>
                        <option value="Chilled (0-4°C or 4-8°C)">
                          Chilled (0-4°C or 4-8°C)
                        </option>
                        <option className=" " value="Frozen (Minus 18°C)">
                          Frozen (Minus 18°C)
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="px-2 mb-8">
                    <p className="font-medium">Capacity Of Vehicle</p>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        value="1 MT"
                        checked={vehicleCapacity === "1 MT"}
                        onChange={(e) => setVehicleCapacity(e.target.value)}
                        type="radio"
                        name="option11"
                        className="w-[20px] h-[20px]"
                      />
                      1 MT
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        value="2 MT"
                        checked={vehicleCapacity === "2 MT"}
                        onChange={(e) => setVehicleCapacity(e.target.value)}
                        name="option11"
                        className="w-[20px] h-[20px]"
                      />
                      2 MT
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        value="6 MT"
                        checked={vehicleCapacity === "6 MT"}
                        onChange={(e) => setVehicleCapacity(e.target.value)}
                        name="option11"
                        className="w-[20px] h-[20px]"
                      />
                      6 MT
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        value="9 MT"
                        checked={vehicleCapacity === "9 MT"}
                        onChange={(e) => setVehicleCapacity(e.target.value)}
                        name="option11"
                        className="w-[20px] h-[20px]"
                      />
                      9 MT
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        value="15 MT"
                        checked={vehicleCapacity === "15 MT"}
                        onChange={(e) => setVehicleCapacity(e.target.value)}
                        name="option11"
                        className="w-[20px] h-[20px]"
                      />
                      15 MT
                    </div>
                  </div>

                  <div className="px-2 mb-8">
                    <p className="font-medium">Nature of Products</p>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        value="Veg"
                        checked={natureOfProduct === "Veg"}
                        onChange={(e) => setNatureOfProduct(e.target.value)}
                        name="option12"
                        className="w-[20px] h-[20px]"
                      />
                      Veg
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        value="Non Veg"
                        checked={natureOfProduct === "Non Veg"}
                        onChange={(e) => setNatureOfProduct(e.target.value)}
                        name="option12"
                        className="w-[20px] h-[20px]"
                      />
                      Non Veg
                    </div>
                    <div className="flex items-center gap-3 mt-3 text-[15px]">
                      <input
                        type="radio"
                        value="Icecream"
                        checked={natureOfProduct === "Icecream"}
                        onChange={(e) => setNatureOfProduct(e.target.value)}
                        name="option12"
                        className="w-[20px] h-[20px]"
                      />
                      Icecream
                    </div>
                  </div>
                  {temperature === "Dry" && natureOfProduct === "Icecream" && (
                    <p className="text-red-500 m-2 font-medium">
                      This product might get damaged in Dry temperature.
                    </p>
                  )}

                  {/* <div className='px-2 mb-8'>
                  <p className='font-medium'>Reporting City</p>
                  <div className='flex items-center gap-3 mt-3 text-[15px]'>
                    <select
                      value={reportingCity}
                      onChange={e => setReportingCity(e.target.value)}
                      className='w-[300px] px-3 py-2 outline-none border rounded'>
                      <option value="" key="" selected>Please Select</option>
                      <option value="Mumbai" key="">Mumbai</option>
                      <option value="Delhi" key="">Delhi</option>
                      <option value="Pune" key="">Pune</option>
                      <option value="Bangalora" key="">Bangalora</option>
                      <option value="Chennai" key="">Chennai</option>
                      <option value="Hyderabad" key="">Hyderabad</option>
                      <option value="Kolkata" key="">Kolkata</option>
                      <option value="Nasik" key="">Nasik</option>
                      <option value="Goa" key="">Goa</option>
                      <option value="Shirdi" key="">Shirdi</option>
                      <option value="Ahmedabad" key="">Ahmedabad</option>
                      <option value="Surat" key="">Surat</option>
                      <option value="Other" key="">Other</option>
                    </select>
                  </div>
                </div>

                <div className='px-2 mb-8'>
                  <p className='font-medium'>Other</p>
                  <div className='flex items-center gap-3 mt-3 text-[15px]'>
                    <input type="text" value={otherReportingCity} onChange={e => setOtherReportingCity(e.target.value)} className='w-[300px] px-3 py-2 outline-none border rounded' />
                  </div>
                </div>

            

                <div className='px-2 mb-8'>
                  <p className='font-medium'>Other</p>
                  <div className='flex items-center gap-3 mt-3 text-[15px]'>
                    <input value={otherDestinationCity} onChange={e => setOtherDestinationCity(e.target.value)} type="text" className='w-[300px] px-3 py-2 outline-none border rounded' />
                  </div>
                </div> */}
                  <div className="flex flex-col gap-6 my-4 ml-2">
                    {/* Origin City Dropdown */}
                    <select
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                      className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                    >
                      <option value="">Select City</option>
                      {[
                        "Mumbai",
                        "Lucknow",
                        "Bangalore",
                        "Delhi NCR",
                        "Hyderabad",
                        "Chennai",
                        "Other",
                      ].map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>

                    {/* Destination City Dropdown */}
                    {selectedCity !== "Other" && (
                      <select
                        value={destinationCity}
                        onChange={(e) => setDestinationCity(e.target.value)}
                        className="w-[300px] px-3 py-2 border border-gray-300 rounded focus:border-red-500 focus:ring-0"
                      >
                        <option value="">Select Destination City</option>
                        {[
                          "Mumbai",
                          "Bangalore",
                          "Delhi NCR",
                          "Hyderabad",
                          "Chennai",
                          "Other",
                        ]
                          .filter((city) => city !== selectedCity) // Exclude the selected origin city
                          .map((city) => (
                            <option key={city} value={city}>
                              {city}
                            </option>
                          ))}
                      </select>
                    )}
                  </div>

                  {selectedCity !== "Other" ||
                    (destinationCity !== "Other" && (
                      <div>
                        <input
                          type="text"
                          placeholder="Please enter your city"
                          min={0}
                          className=" border px-3 py-2 rounded w-[300px] ml-2 my-4"
                        />
                      </div>
                    ))}

                  {selectedCity !== "Other" && destinationCity !== "Other" && (
                    <div>
                      <div className="relative">
                        {/* Pick Up Location */}
                        <div className="px-2 mb-5">
                          <Autocomplete
                            value={pickUpLocation}
                            onInputChange={(_, newInputValue) =>
                              setPickUpLocation(newInputValue)
                            }
                            options={pickUpSuggestions}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Choose  Pick-up location"
                              />
                            )}
                          />
                        </div>

                        {/* Render multiple Drop Locations */}
                        {dropLocation.map((location, index) => (
                          <div key={index} className="px-2 mb-5 relative group">
                            <Autocomplete
                              value={location}
                              onInputChange={(_, newInputValue) =>
                                updateDropLocation(index, newInputValue)
                              }
                              options={pickUpSuggestions}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={`Choose  Drop location ${index + 1}`}
                                />
                              )}
                            />

                            {/* Add Location Button after selecting a drop location */}
                            {location && index === dropLocation.length - 1 && (
                              <button
                                onClick={addDropLocation}
                                className="mt-2 flex items-center gap-2 text-sm text-blue-600 hover:underline"
                              >
                                <Plus className="w-[14px]" /> Add Location
                              </button>
                            )}

                            {/* Remove Button if more than 1 drop location */}
                            {dropLocation.length > 1 && (
                              <button
                                onClick={() => removeDropLocation(index)}
                                className="absolute top-5 -right-3 text-red-500 text-base hover:underline"
                              >
                                <IoMdCloseCircleOutline />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">KMs run </p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            value={distance}
                            disabled={true}
                            type="text"
                            placeholder="85 km"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                        {pickUpLocation && dropLocation && distance <= 30 && (
                          <p className="text-green-500 text-xs italic">
                            Suggestion!! Kindly use Shared Model
                          </p>
                        )}
                      </div>

                      <div className="px-2  mb-9">
                        <p className="font-medium mb-2">
                          Scope of work (requirement in detail)
                        </p>
                        <textarea
                          value={requirementInDetail}
                          onChange={(e) =>
                            setRequirementInDetail(e.target.value)
                          }
                          cols="30"
                          rows="5"
                          className="w-full border px-3 py-2 rounded"
                        ></textarea>
                      </div>

                      <div className="px-2 mb-8">
                        <p className="font-medium">Tentative Start Date</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="date"
                            value={tentativeStartDate}
                            onChange={(e) =>
                              setTentativeStartDate(e.target.value)
                            }
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                      </div>
                      <div className="px-2 mb-8">
                        <p className="font-medium">Expected Quote</p>
                        <div className="flex items-center gap-3 mt-3 text-[15px]">
                          <input
                            type="text"
                            value={expectedQuate}
                            onChange={(e) => setExpectedQuate(e.target.value)}
                            placeholder="Rs 30000"
                            className="w-[300px] px-3 py-2 outline-none border rounded"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="px-2 mb-8">
                    <p className="font-medium">
                      Please fill in your details to receive a call back
                    </p>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Brand Name</div>
                      <input
                        value={brandName}
                        onChange={(e) => setBrandName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Name</div>
                      <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Email ID</div>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="w-full border px-3 py-2 rounded"
                      />
                      <label className="text-red-500">{emailError}</label>
                    </div>
                    <div className="flex items-center gap-3 mt-3">
                      <div className="w-[100px]">Contact No.</div>
                      <input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        type="text"
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <br /> <label className="text-red-500">{phoneError}</label>
                  </div>

                  {/* <div className='px-2 mb-9'>codersbay-nikhil
                  Do you want a quote for storage too? Click on "Next" and check it out.
                </div> */}
                </div>
                <div className="border-t flex items-center justify-between p-8">
                  <button
                    onClick={() => {
                      setStep(1);
                    }}
                    className="bg-[#167938] px-10 py-3 rounded text-white"
                  >
                    Back
                  </button>
                  <button
                    disabled={loading}
                    onClick={handleSubmit}
                    className="bg-[#142272] px-10 py-3 rounded text-white"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}

            {/* <LocationInput /> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
